export default function /* @ngInject */ stripeExpirationMonths() {
    let months = [];
    for (let m = 1; m <= 12; m++) {
        months.push({val: m, title: m < 10 ? '0' + m : String(m)});
    }
    return months;
}



// WEBPACK FOOTER //
// ./stripe/services/stripe-expiration-months.js